import styled from 'styled-components';

export const ContainerLoading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
